export enum SchematicStatus {
    Draft = 1,
    Published = 2,
    Rejected = 3,
    PrePublish = 4,
}